<template>
    <div>
      <design-designer-form :getDesignDesignerList="getDesignDesignerList" ref="designDesignerFormModal">
                </design-designer-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right;" size="sm" variant="outline-primary"
                  @click="getInfo(0)">{{ $t('designDesigner.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="designDesignerTable"
      ref="designDesignerTable" 
      :columns="columns" 
      :rows="rows"
      styleClass="vgt-table condensed tableSize"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'name'" class="text-nowrap">
            {{ $t('designDesigner.name') }}
          </span>
          <span v-else-if="props.column.field === 'adress'" class="text-nowrap">
            {{ $t('designDesigner.address') }}
          </span>
          <span v-else-if="props.column.field === 'country'" class="text-nowrap">
            {{ $t('designDesigner.country') }}
          </span>
          <span v-else-if="props.column.field === 'nationality'" class="text-nowrap">
            {{ $t('designDesigner.nationality') }}
          </span>
          <span v-else-if="props.column.field === 'designPriorityRight'" class="text-nowrap">
            {{ $t('designDesigner.priority_right') }}
          </span>
          <span v-else-if="props.column.field === 'isPrivacyRequest'" class="text-nowrap">
            {{ $t('designDesigner.is_privacy_request') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'isPrivacyRequest'" class="text-nowrap">
            <b-form-checkbox disabled v-model="props.row.isPrivacyRequest"/>
          </span>
          <!-- Column: Process -->
          <span v-else-if="props.column.field === 'process'">
            <span>
              <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary"
              class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
              <feather-icon icon="EditIcon" />
            </b-button>
              <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      designId: Number
    },
    data() {
      return {
        dir: false,
        columns: [
          {
            label: this.$t('designDesigner.name'),
            field: 'name',
          },
          {
            label: this.$t('designDesigner.address'),
            field: `address`,
          },
          {
            label: this.$t('designDesigner.country'),
            field: `country`,
          },
          {
            label: this.$t('designDesigner.nationality'),
            field: `nationality`,
          },
          {
            label: this.$t('designDesigner.design_priority_right'),
            field: `designPriorityRight`
          },
          {
            label: this.$t('designDesigner.is_privacy_request'),
            field: `isPrivacyRequest`
          },
          {
            label: 'Process',
            field: 'process',
            width: '10em'
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getDesignDesignerList()
    },
    methods: {
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'DesignDesigner' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getDesignDesignerList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getDesignDesignerList()
              }
            })
          }
        })
      },
      async getInfo(id) {
        this.$refs.designDesignerFormModal.showInfo(id, this.designId)                
      },
      getDesignDesignerList() {
        this.rows = [] 
        const data = { id: this.designId }
        const controller = { name: 'DesignDesigner', actionName:'GetDesignDesignerListByDesignId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
            response.data.designDesignerList.forEach(element => {
              this.rows.push(element)
            })
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      },
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  